<template>
  <div v-if="editing">
    <!-- top edge -->
    <draggable-div
      :settings="topSettings"
      :scale-factor="scaleFactor"
      lockX
      @drag-move="onTopMove"
    ></draggable-div>
    <!-- left edge -->
    <draggable-div
      :settings="leftSettings"
      :scale-factor="scaleFactor"
      lockY
      @drag-move="onLeftMove"
    ></draggable-div>
    <!-- right edge -->
    <draggable-div
      :settings="rightSettings"
      :scale-factor="scaleFactor"
      lockY
      @drag-move="onRightMove"
    ></draggable-div>
    <!-- bottom edge -->
    <draggable-div
      :settings="bottomSettings"
      :scale-factor="scaleFactor"
      lockX
      @drag-move="onBottomMove"
    ></draggable-div>
    <div v-if="hovered"
      style="
        position: absolute;
        pointer-events: none;
        border-radius: 3px;
      "
      :style="{
        'background-color': 'transparent',
        border: `${thickness}px solid ${(settings.color ? settings.color : 'black')}`,
        top: `${settings.yPos - thickness}px`,
        left: `${settings.xPos - thickness}px`,
        width: `${settings.width + (3 * thickness)}px`,
        height: `${settings.height + (3 * thickness)}px`,
      }"
    ></div>
  </div>
  <div v-else-if="hovered"
    style="
      position: absolute;
      pointer-events: none;
      border-radius: 3px;
    "
    :style="{
      'background-color': 'transparent',
      border: `${thickness}px solid ${(settings.color ? settings.color : 'black')}`,
      top: `${settings.yPos}px`,
      left: `${settings.xPos}px`,
      width: `${settings.width}px`,
      height: `${settings.height}px`,
    }"
  ></div>
</template>

<script>
import DraggableDiv from './DraggableDiv';

export default {
  props: {
    /** expects `xPos`, `yPos`, `width`, `height`, `color` */
    settings: { type: Object },
    hovered: { type: Boolean },
    editing: { type: Boolean },
    scaleFactor: { type: Number },
  },
  components: {
    DraggableDiv,
  },
  data() {
    return {
      thickness: 6,
      topSettings: {
        xPos: 0,
        yPos: 0,
        height: 0,
        width: 0,
        color: '',
      },
      leftSettings: {
        xPos: 0,
        yPos: 0,
        height: 0,
        width: 0,
        color: '',
      },
      rightSettings: {
        xPos: 0,
        yPos: 0,
        height: 0,
        width: 0,
        color: '',
      },
      bottomSettings: {
        xPos: 0,
        yPos: 0,
        height: 0,
        width: 0,
        color: '',
      },
    };
  },
  methods: {
    computeEdgeSettings() {
      console.log('computeEdgeSettings');
      console.log(this.settings.xPos);
      console.log(this.settings.yPos);
      console.log(this.settings.height);
      console.log(this.settings.width);
      console.log('topSettings before:');
      console.log(this.topSettings.xPos);
      console.log(this.topSettings.yPos);
      console.log(this.topSettings.height);
      console.log(this.topSettings.width);
      this.topSettings.color = this.settings.color;
      this.topSettings.xPos = +this.settings.xPos;
      this.topSettings.yPos = +this.settings.yPos;
      this.topSettings.width = +this.settings.width;
      this.topSettings.height = +this.thickness;
      console.log('topSettings after:');
      console.log(this.topSettings.xPos);
      console.log(this.topSettings.yPos);
      console.log(this.topSettings.height);
      console.log(this.topSettings.width);
      this.leftSettings.color = this.settings.color;
      this.leftSettings.xPos = +this.settings.xPos;
      this.leftSettings.yPos = +this.settings.yPos;
      this.leftSettings.width = +this.thickness;
      this.leftSettings.height = +this.settings.height;
      this.rightSettings.color = this.settings.color;
      this.rightSettings.xPos = +this.settings.xPos + +this.settings.width;
      this.rightSettings.yPos = +this.settings.yPos;
      this.rightSettings.width = +this.thickness;
      this.rightSettings.height = +this.settings.height + +this.thickness;
      this.bottomSettings.color = this.settings.color;
      this.bottomSettings.xPos = +this.settings.xPos;
      this.bottomSettings.yPos = +this.settings.yPos + +this.settings.height;
      this.bottomSettings.width = +this.settings.width + +this.thickness;
      this.bottomSettings.height = +this.thickness;
      console.log('computeEdgeSettings end');
    },
    onTopMove() {
      console.log('onTopMove');
      this.settings.yPos = +this.topSettings.yPos;
      this.settings.height = +this.bottomSettings.yPos - +this.topSettings.yPos;
      console.log('onTopMove end');
    },
    onLeftMove() {
      console.log('onLeftMove');
      this.settings.xPos = +this.leftSettings.xPos;
      this.settings.width = +this.rightSettings.xPos - +this.leftSettings.xPos;
      console.log('onLeftMove end');
    },
    onRightMove() {
      this.settings.width = +this.rightSettings.xPos - +this.settings.xPos;
    },
    onBottomMove() {
      this.settings.height = +this.bottomSettings.yPos - +this.settings.yPos;
    },
  },
  watch: {
    settings: {
      handler() {
        this.computeEdgeSettings();
      },
      deep: true
    }
  },
  created() {
    this.computeEdgeSettings();
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/ui/ResizeableBox.vue